import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../campaign-os';
import { usePageChromeState } from './PageChrome';


/**
 * CampaignOS top bar. Ported from D:\campaigning-system\src\layout\TopBar.tsx
 * (cos-* tokens; types stripped). Title/subtitle come from PageChrome; the search
 * and notifications controls are presentational in Phase 0.
 */
export function CampaignTopBar({ onMenu }) {
  const { title, subtitle, actions } = usePageChromeState();
  // Wallet alerts are gone with the Wallet screen; nothing raises a nav alert today.
  const alerts = [];
  const navigate = useNavigate();
  const hasAlerts = alerts.length > 0;
  return (
    <header className="sticky top-0 z-20 border-b border-cos-line-subtle bg-[rgba(247,246,241,0.72)] backdrop-blur-[18px]">
      <div className="flex h-16 items-center gap-3 px-4 sm:gap-4 sm:px-6 xl:px-8">
        <button
          onClick={onMenu}
          aria-label="Open navigation"
          className="grid h-10 w-10 shrink-0 place-items-center rounded-xl border border-cos-line bg-white/60 text-cos-ink-secondary transition-colors hover:text-cos-teal-deep lg:hidden"
        >
          <Icon name="menu" className="text-[20px]" />
        </button>
        <div className="min-w-0">
          <h1 className="truncate text-[19px] font-bold leading-tight tracking-tight text-cos-ink">{title}</h1>
          {subtitle && <div className="truncate text-[13px] leading-tight text-cos-ink-secondary">{subtitle}</div>}
        </div>

        <div className="ml-auto flex items-center gap-2.5">
          {/* Global search (presentational in Phase 0) */}
          <label className="hidden items-center gap-2 rounded-xl border border-cos-line bg-white/60 px-3 py-2 text-sm text-cos-ink-muted transition-colors focus-within:border-cos-teal focus-within:shadow-cos-teal-glow lg:flex">
            <Icon name="search" className="text-[19px]" />
            <input
              type="text"
              placeholder="Search vendors, campaigns…"
              className="w-44 border-0 p-0 shadow-none focus:ring-0 focus:!shadow-none bg-transparent text-cos-ink placeholder:text-cos-ink-muted focus:outline-none xl:w-56"
            />
            <kbd className="mono rounded-md border border-cos-line bg-white/70 px-1.5 py-0.5 text-2xs text-cos-ink-muted">/</kbd>
          </label>

          <button
            onClick={() => hasAlerts && navigate(alerts[0].to)}
            className="relative grid h-10 w-10 place-items-center rounded-xl border border-cos-line bg-white/60 text-cos-ink-secondary transition-colors hover:border-cos-teal/40 hover:text-cos-teal-deep"
            aria-label={hasAlerts ? `${alerts.length} notification(s)` : 'Notifications'}
            title={hasAlerts ? alerts[0].message : 'No new notifications'}
          >
            <Icon name="notifications" className="text-[20px]" />
            {hasAlerts && (
              <span className="absolute -right-1 -top-1 grid h-4 min-w-[16px] place-items-center rounded-full bg-cos-status-coral px-1 text-[10px] font-bold text-white ring-2 ring-white">
                {alerts.length}
              </span>
            )}
          </button>

          {actions && <div className="flex items-center gap-2.5">{actions}</div>}
        </div>
      </div>
    </header>
  );
}

export default CampaignTopBar;
